import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import React from 'react';

export const ConfirmModalMEP = ({
  isOpen,
  handleClose,
  handleConfirm,
  formData,
}) => {
  const handleCopy = () => {
    const releaseInfos =
      formData?.releaseNumber && formData?.link
        ? `Numéro de release: ${formData?.releaseNumber}
        Détails: ${formData?.link}`
        : '';
    const textToCopy = `Informations du déploiement :
      Responsable : ${formData?.author.firstName} ${formData?.author.lastName}
      Dernière mise à jour : ${formData?.updatedAt?.toLocaleString('fr')}
      Début: ${formData?.scheduledAt.toLocaleString('fr')}
      Fin estimée: ${formData?.estimedEndAt ? formData?.estimedEndAt.toLocaleString('fr') : 'Non renseignée'}
      ${releaseInfos}`;
    navigator.clipboard.writeText(textToCopy);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          borderBottom: 1,
          marginBottom: 3,
          display: 'flex',
          gap: 4,
          alignItems: 'center',
          fontSize: 24,
          color: 'primary.main',
        }}
      >
        <SettingsSuggestIcon fontSize="large" />
        Confirmation de la programmation du déploiement
      </DialogTitle>

      <DialogContent
        sx={{
          maxHeight: '75vh',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h6" color="primary">
            Informations du déploiement
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, ml: 2 }}>
            <Typography>
              <strong>Responsable:</strong> {formData?.author.firstName}{' '}
              {formData?.author.lastName}
            </Typography>
            <Typography>
              <strong>Dernière mise à jour:</strong>{' '}
              {new Date(formData?.updatedAt).toLocaleString('fr')}
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Typography>
              <strong>Début estimé:</strong>{' '}
              {formData?.scheduledAt?.toLocaleString('fr')}
            </Typography>
            <Typography>
              <strong>Fin estimée:</strong>{' '}
              {formData?.estimedEndAt
                ? formData?.estimedEndAt?.toLocaleString('fr', 'HH:MM')
                : 'Non renseignée'}
            </Typography>

            {formData?.releaseNumber && formData?.link ? (
              <>
                <Typography>
                  <strong>Numéro de release:</strong> {formData?.releaseNumber}
                </Typography>
                <Typography>
                  <strong>Détails:</strong> {formData?.link}
                </Typography>
              </>
            ) : null}

            <Divider sx={{ my: 1 }} />

            <Typography
              color="primary"
              sx={{
                fontStyle: 'italic',
                padding: 2,
                border: 0.5,
                borderColor: 'rgba(0, 0, 0, 0.3)',
                backgroundColor: 'rgba(255, 223, 163, 0.46)',
                borderRadius: 1,
              }}
            >
              Veuillez à bien lire l&apos;aide disponible avant de valider.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{ p: 3, display: 'flex', justifyContent: 'space-between' }}
      >
        <Button
          variant="outlined"
          color="info"
          onClick={handleClose}
          sx={{ marginRight: 2 }}
        >
          Annuler
        </Button>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            onClick={handleCopy}
            endIcon={<ContentCopyIcon />}
          >
            Copier
          </Button>
          <Button variant="outlined" color="success" onClick={handleConfirm}>
            Confirmer
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
